/* Lost & Found 2.0 template-collection.js (C): sort and facet selects, category browser. Collection and search. */
(function () {
  'use strict';

  /* P44: sort keeps every parameter, forces the availability filter and returns to page 1.
     Keep this signature and the two-space closing brace: scripts/test-theme-availability.mjs extracts it. */
  function lfApplySort(sortValue) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortValue);
    url.searchParams.set('filter.v.availability', '1');
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  /* Single-value storefront filter (the Booth select): replaces the parameter, keeps the rest, returns to page 1. */
  function lfApplyFacet(param, value) {
    var url = new URL(window.location.href);
    url.searchParams.delete(param);
    if (value) url.searchParams.set(param, value);
    url.searchParams.set('filter.v.availability', '1');
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  window.lfApplySort = lfApplySort;
  window.lfApplyFacet = lfApplyFacet;

  var define = function (name, cls) { if (!customElements.get(name)) customElements.define(name, cls); };

  /* P43: open on desktop, collapsed at 768 px and below. The server renders the details open, and CSS hides the
     list on small screens until this element is ready, so nothing shifts; without JS the details stay open. */
  define('lf-category-browser', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      if (!this.details || this.mq) return;
      this.mq = window.matchMedia('(min-width: 769px)');
      this.sync = () => { this.details.open = this.mq.matches; };
      this.sync();
      if (this.mq.addEventListener) this.mq.addEventListener('change', this.sync);
      this.classList.add('is-ready');
    }
    disconnectedCallback() {
      if (this.mq && this.mq.removeEventListener) this.mq.removeEventListener('change', this.sync);
      this.mq = null;
    }
  });

  /* Selects that navigate. A pick from the option list applies at once. A change made by arrowing on the closed
     select (Windows and Linux fire change in the same task as the key) waits for Enter or for focus to leave, so
     browsing the options never reloads the page by surprise (WCAG 3.2.2). */
  define('lf-facet-select', class extends HTMLElement {
    connectedCallback() {
      var select = this.querySelector('select');
      if (!select || this.bound) return;
      this.bound = true;
      var param = this.getAttribute('data-param');
      var initial = select.value, keyed = false, pending = false, busy = false;
      var go = function () {
        if (busy || select.value === initial) return;
        busy = true;
        select.setAttribute('aria-busy', 'true');
        if (param === 'sort_by') lfApplySort(select.value); else lfApplyFacet(param, select.value);
      };
      select.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { if (select.value !== initial) { e.preventDefault(); go(); } return; }
        if (e.key === 'Tab' || e.key === 'Escape') return;
        keyed = true;
        setTimeout(function () { keyed = false; }, 0);
      });
      select.addEventListener('change', function () { if (keyed) { pending = true; return; } go(); });
      select.addEventListener('blur', function () { if (pending) go(); });
    }
  });
})();
